const Environment = {
  PRODUCTION: true,
  PASSAGE_BASE: 'https://api.nodoelparque.in',
  PASSAGE_VIEWER: 'https://api.nodoelparque.in/viewer',
  PASSAGE_API_URL: 'https://api.nodoelparque.in/api',
  CONTABLE_WEB_URL: 'http://contableweb.nodoelparque.in',
  PASSAGE_API_VERSION: 'V1',
  PASSAGE_APP_VERSION: 'v1.5.14'
}

export default Environment
